import { Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import DefaultButton from "components/Button/PrimaryButton";
import ImpostosForm from "./../ImpostosForm/index";
import useGetImposto from "core/features/fornecedores/hooks/useGetImposto";
import usePutImposto from "core/features/fornecedores/hooks/usePutImposto";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { FornecedorImposto } from "core/features/fornecedores/typings/index";
import { useLoading } from "ui/components/GlobalLoading";
import OutlineButton from "ui/components/Button/OutlineButton";
import history from "infra/helpers/history";
import { TipoAliquota } from "ui/components/Input/SelectAliquota/index";

interface ImpostosProps {
  id?: string;
}

function Impostos({ id }: ImpostosProps) {
  const { data, isLoading, isFetching } = useGetImposto(id);
  const { mutate: handleSave, isLoading: isSaveLoading } = usePutImposto(id);
  const { control, watch, handleSubmit, setValue, reset } =
    useForm<FornecedorImposto>({});

  const onSubmit = async (data: FornecedorImposto) => {
    handleSave(data, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess();
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({
        impostos: data.map((item) => ({
          id: item.id,
          aliquota: item.aliquota,
          impostoId: item.impostoId,
          reterImposto: item.reterImposto,
          imposto: item.imposto,
          aliquotaId: item.aliquota
            ? TipoAliquota.AliquotaFornecedor
            : TipoAliquota.Padrao,
        })),
      });
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <>
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <ImpostosForm control={control} setValue={setValue} watch={watch} />

        <Flex mt="16px" gap={4} justifyContent={"flex-end"}>
          <OutlineButton
            onClick={() => history.push(`/cadastros/fornecedores`)}
          >
            Voltar
          </OutlineButton>
          <DefaultButton
            type="submit"
            isLoading={isSaveLoading}
            disabled={isSaveLoading}
          >
            Salvar
          </DefaultButton>
        </Flex>
      </form>
    </>
  );
}

export default Impostos;
